(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name paymentTemplates.controller:TemplateListOverviewCtrl
   *
   * @description
   *
   */
  angular
    .module('paymentTemplates')
    .controller('TemplateListOverviewCtrl', TemplateListOverviewCtrl);

  function TemplateListOverviewCtrl($rootScope) {
    var vm = this;
  }
}());
